import { ClinicWidgetRequestType, WidgetRequestType } from 'shared/types/graphql';
import { IconName } from '@televet/kibble-ui/build/components/Icon';
import { WidgetRequestTypeLabels } from '@televet/shared-types/widgetRequest/WidgetRequestTypeLabels';

export const WidgetRequestTypeIconNames: Record<string, IconName> = {
  [WidgetRequestType.RequestAppointment]: 'calendarPen',
  [WidgetRequestType.RequestBoarding]: 'house',
  [WidgetRequestType.RequestGroomingAppoinment]: 'cut',
  [WidgetRequestType.RequestRxRefill]: 'pill',
  [WidgetRequestType.AdvancedRequestRxRefill]: 'pill',
  [WidgetRequestType.TalkToStaff]: 'support',
  [WidgetRequestType.InboundSms]: 'cellphone',
  [WidgetRequestType.RequestMedicalRecords]: 'fileHealth',
  [WidgetRequestType.RequestVirtualConsult]: 'videoCamera',
  [WidgetRequestType.DirectBooking]: 'calendarDate',
  [WidgetRequestType.Teletriage]: 'chatBubble',
  [WidgetRequestType.LiveAgent]: 'liveagent',
};

export const getClinicWidgetRequestTypeDisplayName = (
  widgetRequestType: ClinicWidgetRequestType | Pick<ClinicWidgetRequestType, 'displayName' | 'requestType'>,
): string => {
  return widgetRequestType?.displayName || WidgetRequestTypeLabels[widgetRequestType.requestType];
};
